import {z} from "zod";

export const loginSchema = z.object({
    username: z.string().min(1,'El nombre de usuario es requerido').max(100,'El nombre de usuario no puede superar los 100 caracteres'),
    password:z.string().min(1,'La contraseña es requerida').max(100,'La contraseña no puede superar los 100 caracteres')
});